import LogRocket from 'logrocket';
import { AppProps } from 'next/app';
import 'styles/global/global.less';
import { continueExistingLogRocketSession } from '@zola-helpers/client/dist/es/util/logrocket/logRocketUtils';
import 'intersection-observer';
import { useEffect } from 'react';

export default function App({
  Component,
  pageProps,
  err,
}: AppProps & {
  err?: unknown;
}): JSX.Element {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.LogRocket = LogRocket;
      continueExistingLogRocketSession();
    }
  }, []);
  return <Component {...pageProps} err={err} />;
}
